export enum LocalStorage {
  TOKEN = 'TOKEN',
  TOKEN_TMP = 'TOKEN_TMP',
  UID = 'UID',
  LANG = 'LANG',
  MENU_OPEN = 'MENU_OPEN',
  RED_NOTIFICATION = 'RED_NOTIFICATION',
}
